var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReceivingEmptyImg = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 128,
    viewBox: "0 0 107 128",
    fill: "#D9D9D9",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22949 94.3491L19.3045 88.2858L18.5298 89.6911L13.8305 92.0582V92.4234L39.6848 105.411L41.1295 104.683L49.4036 108.493L70.0459 98.8526C72.1135 97.8872 74.1501 96.8558 76.1528 95.7605L91.6717 87.272L95.8734 78.1115L100.202 80.2861V80.6513L96.3621 82.3967L93.3337 89.369L77.8146 97.8575C75.8121 98.9529 73.7755 99.9842 71.7077 100.95L51.0654 110.59L40.5666 110.306L39.6916 110.747L7.22949 94.3491Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5378 73.8103L75.1237 82.0113L65.2086 77.0575L22.9316 96.6442L49.2612 108.709L69.9076 99.113C71.9757 98.152 74.0127 97.1254 76.0158 96.0351L91.5378 87.5856L96.2224 77.421V77.0575L91.5378 73.8103Z",
    fill: "#F3C456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.24 103.285L49.2602 108.709L38.6934 104.52L44.24 103.285Z",
    fill: "#DEA24E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2604 108.709L50.5738 99.2377L44.2402 103.285L49.2604 108.709Z",
    fill: "#EDB654"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5377 87.5855L89.8887 79.6606L96.2222 77.4209L91.5377 87.5855Z",
    fill: "#EDB654"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3623 64.1297L96.2219 77.0574L100.063 75.32L74.2034 62.3923L70.3623 64.1297Z",
    fill: "#FFE092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2402 102.921V103.285L50.5738 99.2377L89.8884 79.6607L96.2219 77.421V77.0575L91.5374 73.8103L51.8791 88.1734L44.2402 102.921Z",
    fill: "#BF8B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6807 92.7132L39.5403 105.641L44.2405 103.285V102.921L18.381 90.3571L13.6807 92.3497V92.7132Z",
    fill: "#BF8B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6807 92.3497L39.5403 105.277L44.2405 102.921L18.381 89.9935L13.6807 92.3497Z",
    fill: "#FFE092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9316 81.778L49.2612 94.9331L62.2557 87.5339C67.1784 84.7309 72.2488 82.1945 77.4447 79.936L91.5378 73.8102L65.2086 60.6552C65.2086 60.6552 52.2196 65.9873 45.3311 69.5117C37.7518 73.3895 22.9316 81.778 22.9316 81.778Z",
    fill: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3809 89.9936L22.9314 81.7781L49.2609 94.9331L44.2405 102.921L18.3809 89.9936Z",
    fill: "#F3B63D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0825 71.4816L53.361 68.1085C53.1974 68.0268 53.1974 67.8944 53.361 67.8128L62.7344 63.1294C62.8978 63.0478 63.1627 63.0478 63.326 63.1294L70.0476 66.5026C70.2109 66.5842 70.2109 66.7166 70.0476 66.7983L60.6741 71.4816C60.5108 71.5632 60.2459 71.5632 60.0825 71.4816Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5799 66.7982L60.6737 71.248C60.5104 71.3297 60.2455 71.3297 60.0821 71.248L53.8276 68.1084C53.6642 68.0268 53.6642 67.8943 53.8276 67.8127L62.734 63.3628C62.8974 63.2812 63.1622 63.2812 63.3256 63.3628L69.5799 66.5025C69.7435 66.5841 69.7435 66.7166 69.5799 66.7982Z",
    fill: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4724 64.2616L54.8146 68.0878L54.6035 67.9822L62.2613 64.1562L62.4724 64.2616Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9704 64.5111L55.3127 68.3371L55.1016 68.2317L62.7593 64.4055L62.9704 64.5111Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4707 64.7601L55.8129 68.5864L55.6016 68.4808L63.2593 64.6548L63.4707 64.7601Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9685 65.0096L56.3109 68.8356L56.0996 68.73L63.7574 64.9041L63.9685 65.0096Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4675 65.2588L56.8097 69.085L56.5986 68.9794L64.2564 65.1532L64.4675 65.2588Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6736 65.9031L62.8468 68.3147L62.6357 68.2091L67.4625 65.7975L67.6736 65.9031Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1727 66.1522L63.3459 68.5639L63.1348 68.4585L67.9616 66.0469L68.1727 66.1522Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6717 66.4017L63.8449 68.8134L63.6338 68.7078L68.4606 66.2961L68.6717 66.4017Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2374 65.2594L57.5176 69.616L57.6308 69.6727L66.3506 65.3158L66.2374 65.2594Z",
    fill: "#4F2E16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9466 103.344L13.6807 92.7132V92.3497L34.9468 102.981H34.9466V103.344Z",
    fill: "#B0803E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4309 101.517L32.9004 100.291L35.1114 98.9398C35.276 98.8393 35.4262 98.7187 35.5593 98.5816C35.7037 98.4324 35.8278 98.2636 35.9274 98.0795L39.9474 90.6424C40 90.545 40.0655 90.4559 40.142 90.3774C40.2123 90.305 40.2916 90.2416 40.3786 90.1885L43.6933 88.1733L46.2703 89.3549L42.8552 91.5266C42.7971 91.5636 42.7425 91.6053 42.6919 91.6513C42.5979 91.737 42.5176 91.8373 42.4546 91.949L38.2924 99.3316C38.2 99.4951 38.0883 99.6462 37.9596 99.7816C37.8401 99.9073 37.7061 100.02 37.5602 100.116L35.4309 101.517Z",
    fill: "#9B7451"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceivingEmptyImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receivingEmptyImg.6767832c.svg";
export { ForwardRef as ReactComponent };